/** Названия банков  */
export const enum BANK_NAME {
  DEFAULT = "Стандартный",
  KKB = "Камкомбанк",
}

/** Cтатус заявки в банк */
export type ApplicationBankStatus = {
  id: number;
  title: string;
  color: string;
  info: string;
  info_color: string;
  type: string;
  bank_name: BANK_NAME;
};

/** Cтатус заявки в банк для Guard*/
export type ApplicationBankGuardStatus = Pick<
  ApplicationBankStatus,
  "bank_name" | "type"
>;

/** Статусы банка Стандартный */
export const enum APPLICATION_BANK_STATUS_DEFAULT {
  DIRECTED = "directed", // Направлена
  OFFER = "offer", // Предложение
  REJECTED = "rejected", // Отказ
  ISSUED = "issued", // Выдана
  REVISION = "revision", // На доработку
  REQUIRED_SIGNATURE = "required_signature", // Требуется подписание
}

// /** Статусы банка Камкомбанк */
export const enum APPLICATION_BANK_STATUS_KKB {
  PROCESSING = "processing", // В обработке
  SIGNING = "signing", // Требуется подписание (появляются документы для подписания)
  RESIGNING = "re_signing_first_stage", // требуется повторное подписание
  DOCUMENT_SIGNED = "document_signed", // Документы подписаны
  DIRECTED = "directed", // Направлена
  REVISION = "revision", // На доработке
  REFUSAL = "refusal", // Отказ
  OFFER = "offer", // Предложение (появляются документы от банка)
  AWAITING_PAYMENT = "awaiting_payment", // Требуется оплата
  PAID = "paid", // Оплачено
  SIGNATURE_REQUIRED = "signature_required", // Требуется подписание (подписание документов от банка)
  PROCESSED_BY_BANK = "processed_by_bank", // Подписано клиентом
  DEAL_COMPLETED = "deal_completed", // Сделка завершена
}

/**
 * Список статусов заявок в банк для гуарда
 */
export const ApplicationBankGuardStatuses: ApplicationBankGuardStatus[] = [
  /**
   * Cтатусы заявок в банк Стандартный
   */
  {
    bank_name: BANK_NAME.DEFAULT,
    type: APPLICATION_BANK_STATUS_DEFAULT.DIRECTED,
  }, // Направлена
  { bank_name: BANK_NAME.DEFAULT, type: APPLICATION_BANK_STATUS_DEFAULT.OFFER }, // Предложение
  {
    bank_name: BANK_NAME.DEFAULT,
    type: APPLICATION_BANK_STATUS_DEFAULT.REJECTED,
  }, // Отказ
  {
    bank_name: BANK_NAME.DEFAULT,
    type: APPLICATION_BANK_STATUS_DEFAULT.ISSUED,
  }, // Выдана
  {
    bank_name: BANK_NAME.DEFAULT,
    type: APPLICATION_BANK_STATUS_DEFAULT.REVISION,
  }, // На доработку
  {
    bank_name: BANK_NAME.DEFAULT,
    type: APPLICATION_BANK_STATUS_DEFAULT.REQUIRED_SIGNATURE,
  }, // Требуется подписание

  /**
   *Cтатусы заявок в банк Камкобанк
   */
  { bank_name: BANK_NAME.KKB, type: APPLICATION_BANK_STATUS_KKB.PROCESSING },
  { bank_name: BANK_NAME.KKB, type: APPLICATION_BANK_STATUS_KKB.SIGNING },
  {
    bank_name: BANK_NAME.KKB,
    type: APPLICATION_BANK_STATUS_KKB.DOCUMENT_SIGNED,
  },
  { bank_name: BANK_NAME.KKB, type: APPLICATION_BANK_STATUS_KKB.DIRECTED },
  { bank_name: BANK_NAME.KKB, type: APPLICATION_BANK_STATUS_KKB.REVISION },
  { bank_name: BANK_NAME.KKB, type: APPLICATION_BANK_STATUS_KKB.OFFER },
  {
    bank_name: BANK_NAME.KKB,
    type: APPLICATION_BANK_STATUS_KKB.AWAITING_PAYMENT,
  },
  { bank_name: BANK_NAME.KKB, type: APPLICATION_BANK_STATUS_KKB.PAID },
  {
    bank_name: BANK_NAME.KKB,
    type: APPLICATION_BANK_STATUS_KKB.SIGNATURE_REQUIRED,
  },
  {
    bank_name: BANK_NAME.KKB,
    type: APPLICATION_BANK_STATUS_KKB.PROCESSED_BY_BANK,
  },
  {
    bank_name: BANK_NAME.KKB,
    type: APPLICATION_BANK_STATUS_KKB.DEAL_COMPLETED,
  },
];
